'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'question';
var width = 320;
var height = 512;
var aliases = [10067,10068,61736];
var unicode = '3f';
var svgPathData = ['M128 448l64 0 0 64-64 0 0-64z', 'M160.1 0c88.3 0 160.1 71.6 160 160-.1 55.1-28.7 108.9-80 138.5l-48 27.7 0 57.7-64 0 0-94.7c2.7-1.5 29.3-16.9 80-46.2 30.7-17.7 48-49.9 48-83.2 0-53-43-96-96-96-53 0-96 43-96 96l0 32-64 0 0-32C0 71.6 71.7 0 160.1 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faQuestion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;